__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-24-1774345799-stable-dev/";